<script setup>
import CardBox from '@/components/CardBox.vue'
import BaseLevel from '@/components/BaseLevel.vue'

const props = defineProps({
  transaction_no: {
    type: String,
    required: true
  },
  info: {
    type: String,
    required: true
  },
  employee_name: {
    type: String,
    required: true
  }
})
</script>

<template>
  <CardBox class="mb-6 last:mb-0" is-hoverable>
    <BaseLevel>
      <BaseLevel type="justify-start">
        <div class="text-center space-y-1 md:text-left">
          <p class="text-xl">{{ props.info }}</p>
          <p class="">
            <b>{{ props.employee_name }} ({{ props.transaction_no }})</b>
          </p>
        </div>
      </BaseLevel>
    </BaseLevel>
  </CardBox>
</template>
